module.exports = __webpack_public_path__ + "static/img/Karla.263db11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Karla.jpg
// module id = was2
// module chunks = 5